import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import htmlbars from 'react-syntax-highlighter/dist/esm/languages/hljs/htmlbars';
import docco from 'react-syntax-highlighter/dist/esm/styles/hljs/docco';

interface CodeHighlightProps {
    children: string;
}

SyntaxHighlighter.registerLanguage('htmlbars', htmlbars);

const CodeHighlight = ({ children }: CodeHighlightProps) => {
    return (
        <SyntaxHighlighter
            wrapLongLines
            customStyle={{ fontSize: '12px' }}
            language={htmlbars as string}
            style={docco}
        >
            {children}
        </SyntaxHighlighter>
    );
};

export default CodeHighlight;
